import React from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import COLORS from 'shared/styles/colors';

import styles from './styles';

interface Props {
  className?: string;
  size?: SizeProp;
  showTooltip?: boolean;
  showHoverBox?: boolean;
  tooltipContent?: string;
}
const WarningStatusBadge: React.FC<Props> = ({
  className,
  size = 'lg',
  showTooltip = false,
  showHoverBox = false,
  tooltipContent = 'Warning Status',
}) => {
  return (
    <Tooltip content={`Warning: ${tooltipContent}`} disabled={!showTooltip} maxWidth={226}>
      <Flex
        css={styles}
        className={cs('warning-status-badge', {
          'warning-status-badge--hover': showHoverBox,
        })}
      >
        <FontAwesomeIcon icon={faExclamationTriangle} size={size} className={className} color={COLORS.RED500} />
      </Flex>
    </Tooltip>
  );
};

export default WarningStatusBadge;
